"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgGridIcon(props) {
  return React.createElement("svg", (0, _extends2.default)({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    preserveAspectRatio: "xMidYMid meet",
    stroke: props.stroke,
    fill: props.fill
  }, props), React.createElement("path", {
    d: "M8.938 13.277a1.79 1.79 0 011.787 1.787v7.149A1.79 1.79 0 018.938 24h-7.15A1.79 1.79 0 010 22.213v-7.15a1.79 1.79 0 011.787-1.786zm13.275 0A1.79 1.79 0 0124 15.064v7.149A1.79 1.79 0 0122.213 24h-7.15a1.79 1.79 0 01-1.786-1.787v-7.15a1.79 1.79 0 011.787-1.786zM8.938 14.809h-7.15a.258.258 0 00-.256.255v7.149c0 .138.117.255.255.255h7.151a.258.258 0 00.256-.255v-7.15a.258.258 0 00-.256-.254zm13.275 0h-7.15a.258.258 0 00-.254.255v7.149c0 .138.116.255.255.255h7.149a.258.258 0 00.255-.255v-7.15a.258.258 0 00-.255-.254zM8.938 0a1.79 1.79 0 011.787 1.787v7.15a1.79 1.79 0 01-1.787 1.786h-7.15A1.79 1.79 0 010 8.936V1.787A1.79 1.79 0 011.787 0zm13.275 0A1.79 1.79 0 0124 1.787v7.15a1.79 1.79 0 01-1.787 1.786h-7.15a1.79 1.79 0 01-1.786-1.787V1.787A1.79 1.79 0 0115.064 0zM8.938 1.532h-7.15a.258.258 0 00-.256.255v7.15c0 .138.117.254.255.254h7.151a.258.258 0 00.256-.255V1.787a.258.258 0 00-.256-.255zm13.275 0h-7.15a.258.258 0 00-.254.255v7.15c0 .138.116.254.255.254h7.149a.258.258 0 00.255-.255V1.787a.258.258 0 00-.255-.255z",
    fill: "inherit",
    fillRule: "evenodd"
  }));
}

var _default = SvgGridIcon;
exports.default = _default;